<template>
  <v-container class="text-center">
    <v-row>
      <v-col>
        <h1 class="mb-5" :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']">Careers at Navigate</h1>
        <p>Be part of something bigger, and smarter</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <v-select
          dense
          outlined
          @change="filterJob"
          v-model="location"
          :items="$t('careers.locations')"></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h2>{{ $t('careers.list-heading') }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(job, index) in jobList" :key="index" cols="12">
        <v-card :to="{ name: 'job', params: { id: job.uid }}" outlined>
          <v-container>
            <v-row class="d-flex">
              <v-col class="text-left font-weight-bold" cols="12" md="4">
                {{ job.data.title[0].text }}
              </v-col>
              <v-col class="text-left">{{ job.data.city}}, {{ job.data.location }}</v-col>
              <a>
                <v-col>
                  <div class="text-end font-weight-bold">{{ $t('careers.apply-now') }}
                  </div>
                </v-col>
              </a>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Careers',
  data () {
    return {
      location: 'all',
      jobList: [],
    };
  },
  methods: {
    fetchJobList(filter) {
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'jobs'), { fetch: ['jobs.title', 'jobs.city', 'jobs.location'], orderings: '[my.jobs.location]' },
      ).then((res) => {
        this.jobList = res.results;
      });
    },
    filterJob() {
      const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);
      if (this.location === 'all') {
        this.fetchJobList();
      } else {
        const filter = capitalize(this.location);
        this.$prismic.client.query(
          this.$prismic.Predicates.at('my.jobs.location', filter), { fetch: ['jobs.title', 'jobs.city', 'jobs.location'] },
        ).then((res) => {
          this.jobList = res.results;
        });
      }
    }
  },
  created() {
    this.fetchJobList();
  },
};
</script>

<style scoped>

</style>
